import React from "react";
import { MotifTooltip } from "@ey-xd/motif-react";
import "./Tooltip.scss";

// Wrapper for Motif tooltip with hover-only display
export function Tooltip({ trigger, variant, tooltipText, className = "", placement = "right" }) {
  return (
    <MotifTooltip
      trigger={trigger}
      variant={variant}
      placement={placement}
      allowClick="false"
      allowHover="true"
      flip="true"
      hideCloseButton="true"
      className={`custom-tooltip ${className}`}
    >
      {tooltipText}
    </MotifTooltip>
  );
}
